import { errorHandler } from '@/business/apiTreatment/response/baseAPITreatment';
import axios from 'axios';
import Client from './tools/client';

function createAndDownloadBlobFile(body, filename, extension = 'xlsx') {
  const blob = new Blob([body]);
  const fileName = `${filename}.${extension}`;
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, fileName);
  } else {
    const link = document.createElement('a');
    // Browsers that support HTML5 download attribute
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}

export default {
  async getItems(body, name) {
    let url = `mypredity_ords2excel/api/v1/excel-export`;
    if (['development'].includes(process.env.NODE_ENV)) {
      url = 'http://localhost:3031/api/v1/excel-export';
      return axios
        .post(url, body, {
          responseType: 'arraybuffer',
          headers: { 'x-api-sub': 'TJ6052' },
        })
        .then((response) => {
          createAndDownloadBlobFile(response.data, `${name}`);
        })
        .catch(errorHandler);
    }
    return Client.post(url, body, {
      responseType: 'arraybuffer',
    })
      .then((response) => {
        createAndDownloadBlobFile(response.data, `${name}`);
      })
      .catch(errorHandler);
  },
};
